// src/components/dashboard/stats/TopDecksMonth.tsx
// ✅ REFATORADO COM PREFIXOS

import React from 'react';
import { TopDeckMonth } from '../types';

interface TopDecksMonthProps {
    topDecks: TopDeckMonth[];
}

const TopDecksMonth: React.FC<TopDecksMonthProps> = ({ topDecks }) => {
    const formatTime = (seconds: number): string => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        if (hours > 0) return `${hours}h ${minutes}min`;
        return `${minutes}min`;
    };

    if (topDecks.length === 0) {
        return (
            <div className="dsb-estx-mes-topdecks">
                <h3>Top 5 Decks do Mês</h3>
                <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
                    Nenhum deck estudado este mês
                </p>
            </div>
        );
    }

    return (
        <div className="dsb-estx-mes-topdecks">
            <h3>Top 5 Decks do Mês</h3>

            <div className="dsb-estx-mes-topdecks-list">
                {topDecks.map((deck, index) => (
                    <div key={deck.deckId} className="dsb-estx-mes-topdeck-item">
                        <div className="dsb-estx-mes-topdeck-info">
                            <div className="dsb-estx-mes-topdeck-name">
                                #{index + 1} {deck.deckName}
                            </div>
                            <div className="dsb-estx-mes-topdeck-meta">
                                {formatTime(deck.timeSpent)} de estudo
                            </div>
                        </div>

                        <div className="dsb-estx-mes-topdeck-stats">
                            <div className="dsb-estx-mes-topdeck-cards">{deck.cardsStudied}</div>
                            <div className="dsb-estx-mes-topdeck-label">cards</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TopDecksMonth;